import { jsonArrayMember, jsonMember, jsonObject } from 'typedjson';
import { Guid, Nillable } from '@web/utils';
import { AdminCosmeticBrandResponse } from './admin-cosmetic-brand.response';
import { AdminCosmeticContextOperationsResponse } from './admin-cosmetic-context-operations.response';
import { MultimediaResponse } from '@web/shared/module/multimedia';
import { AdminCosmeticCharacteristicResponse } from './admin-cosmetic-characteristic.response';
import { AdminCosmeticAttributeResponse } from './admin-cosmetic-attribute.response';
import { AdminCosmeticWarehouseProductResponse } from './admin-cosmetic-warehouse-product.response';
import { AdminCosmeticStatus } from '../../enums/admin-cosmetic-status';

@jsonObject
export class AdminCosmeticDetailsResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly name!: string;

  @jsonMember(Number)
  public readonly price?: Nillable<number>;

  @jsonMember(String)
  public readonly slug!: string;

  @jsonMember(String)
  public readonly status!: AdminCosmeticStatus;

  @jsonMember(String)
  public readonly vendorUrl?: Nillable<string>;

  @jsonMember(Date)
  public readonly createdAt!: Date;

  @jsonMember(MultimediaResponse)
  public readonly featuredFile?: Nillable<MultimediaResponse>;

  @jsonMember(AdminCosmeticBrandResponse)
  public readonly cosmeticBrand?: Nillable<AdminCosmeticBrandResponse>;

  @jsonMember(AdminCosmeticWarehouseProductResponse)
  public readonly warehouseGood?: Nillable<AdminCosmeticWarehouseProductResponse>;

  @jsonMember(AdminCosmeticContextOperationsResponse)
  public readonly contextOperations!: AdminCosmeticContextOperationsResponse;

  @jsonArrayMember(MultimediaResponse)
  public readonly files?: Nillable<MultimediaResponse[]>;

  @jsonArrayMember(AdminCosmeticCharacteristicResponse)
  public readonly characteristics?: AdminCosmeticCharacteristicResponse[];

  @jsonArrayMember(AdminCosmeticAttributeResponse)
  public readonly attributes?: AdminCosmeticAttributeResponse[];
}
